import axios from 'axios';
import { DataTypePlural, Filter, Data } from '@ilteducation/content-ref-data-types';
import { useConfigHelper } from '@ilteducation/config';

const { getApiUrl } = useConfigHelper();

export type Response<T> = {
  cursor: string | null;
  data: T[];
};

export const getRefDatas = <T>(
  type: DataTypePlural,
  cursor: string | null,
  filter?: Filter[],
): Promise<Response<T>> => {
  const qsParts: string[] = [];
  if (cursor) {
    qsParts.push(`cursor=${cursor}`);
  }
  if (filter) {
    qsParts.push(...filter.flatMap((f) => f.value.map((val) => encodeURI(`filter=${f.key}:${val}`))));
  }
  const queryString = qsParts.length ? `?${qsParts.join('&')}` : '';
  const url = `${getApiUrl('content-ref-data', true)}/${type}/search${queryString}`;
  return axios.get(url).then((response) => response.data as Response<T>);
};

export const getRefData = <T>(type: DataTypePlural, contentId: string): Promise<T> =>
  axios.get(`${getApiUrl('content-ref-data', true)}/${type}/${contentId}`).then((response) => response.data as T);

function chunkArray<T>(array: T[], chunkSize: number) {
  const result = [];
  for (let i = 0; i < array.length; i += chunkSize) {
    const chunk = array.slice(i, i + chunkSize);
    result.push(chunk);
  }
  return result;
}

export const getRefDataByIds = async (contentIds: string[]): Promise<Data[]> => {
  const results: Data[] = [];

  // content-ref-data/byIds can only handle 100 ids at a time
  const promises = chunkArray(contentIds, 100).map((chunk) =>
    axios
      .get(`${getApiUrl('content-ref-data', true)}/byIds?ids=${chunk.join(',')}`)
      .then((response) => results.push(...(response.data.data as Data[]))),
  );

  await Promise.all(promises);
  return results;
};
